import React, { Component } from 'react'
import { AboutOrder } from 'features/AboutOrder'
import { ProductSide } from './ProductSide'
import { Regulation } from 'features/Regulation'
import '@loyal_template/cart.css'
import '@loyal_template/confirmation.css'
import PropTypes from 'prop-types'
import clients from 'redux/clients'
import { Alert } from 'loyal-react'

class ProductOrderDetail extends Component {
  constructor (props) {
    super(props)
    this.state = {
      voucherLinkResponse: null,
      hasErrors: false,
      showPlaceholder: false
    }
    this.handleVoucherLink = this.handleVoucherLink.bind(this)
    this.openVoucherLink = this.openVoucherLink.bind(this)
  }

  componentDidMount () {
    this.props.getOrderListDetails(true)
    const {
      tracking: { client: trackingClient },
      cloudloyalty: { client }
    } = clients

    this.client = client
    this.tracking = trackingClient

    this.trackingHandler()

    setTimeout(() => {
      this.setState({ showPlaceholder: true })
    }, 4000)
  }
  handleVoucherLink (model) {
    this.client
      .post(`/v1/purchases/voucherLink`, model)
      .then(response => {
        response.data && response.data.voucherLink
          ? this.openVoucherLink(response.data.voucherLink) &&
          this.setState({ voucherLinkResponse: response.data })
          : this.setState({ voucherLinkResponse: response.data })
      })
      .catch(ex => this.setState({ hasErrors: true }))
  }

  trackingHandler () {
    if (!this.props.orderDetail) return

    let sku = this.props.productDetail && this.props.productDetail.productCode
    if (sku) {
      let splitSku = sku.split('-')
      if (splitSku.length > 0) sku = splitSku[0]
    }

    this.props.orderDetail.orderId &&
      this.tracking
        .get(`/timelines/${this.props.orderDetail.orderId}/items/${sku}`)
        .then(result => {
          this.setState({ trackingObject: result.data })
        })
  }

  openVoucherLink (link) {
    let url = 'http://' + link
    window.open(url, '_blank')
  }

  componentDidUpdate (prevProps) {
    if (this.props.orderDetailNotFoundRedux) {
      this.props.getOrderDetailsApi()
    }

    if (this.props.orderDetail !== prevProps.orderDetail) {
      this.trackingHandler()
    }

    if (
      JSON.stringify(this.props.match.params) !==
      JSON.stringify(prevProps.match.params)
    ) {
      this.props.getOrderListDetails()
    }
  }

  render () {
    return this.props.parentOrderDetail &&
      this.props.orderDetail &&
      this.props.productDetail ? (
        <div className='container-fluid pt-1 pt-md-0'>
          <div className='container pt-0 pt-md-5 pb-0 py-md-4 px-0 px-md-1'>
            <div className='row pt-5 pt-md-0'>
              {this.state.hasErrors ? (
                <Alert isError title={'Erro ao consultar o Voucher.'} />
              ) : (
                ''
              )}
              <Regulation />
              <ProductSide
                {...this.state}
                trackingAlternative={this.props.trackingAlternative}
                productDetail={this.props.productDetail}
                parentOrderDetail={this.props.parentOrderDetail}
                orderDetail={this.props.orderDetail}
                tracking={this.state.trackingObject}
                previousRoute={this.props.previousRoute}
                getVoucherLink={this.props.getVoucherLink}
                handleVoucherLink={this.handleVoucherLink}
                storeConfiguration={this.props.stores.find(
                  store => store.supplierId === this.props.orderDetail.vendorId
                )}
                packageSize={this.props.packageSize}
              />
              <AboutOrder parentOrder={this.props.parentOrderDetail} />
            </div>
          </div>
        </div>
      ) : (
        ''
      )
  }
}

ProductOrderDetail.propTypes = {
  trackingAlternative: PropTypes.object,
  parentOrderDetail: PropTypes.object,
  orderDetail: PropTypes.object,
  tracking: PropTypes.object,
  productDetail: PropTypes.object,
  getOrderListDetails: PropTypes.func,
  previousRoute: PropTypes.string,
  orderDetailNotFoundRedux: PropTypes.bool,
  getOrderDetailsApi: PropTypes.func,
  getVoucherLink: PropTypes.func,
  match: PropTypes.object,
  stores: PropTypes.object,
  packageSize: PropTypes.number
}

export default ProductOrderDetail



// WEBPACK FOOTER //
// ./src/Participant/MyOrders/ProductOrderDetail/ProductOrderDetail.js